export default function LeavesAvatar() {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.8982 8.51687L8.49329 3.11198C9.20769 2.40433 10.1729 2.00789 11.1785 2.00916C11.6804 2.00856 12.1774 2.1072 12.6409 2.29943C13.1046 2.49166 13.5255 2.77367 13.8797 3.12923C14.5938 3.84276 14.9965 4.80982 15 5.81925C15.0034 6.82869 14.6073 7.79847 13.8982 8.51687Z"
        fill="#E75E3C"
        className="path-fill"
      />
      <path
        d="M8.00381 14.4071L2.5989 9.00219L2.12055 8.52498C1.76533 8.17027 1.48353 7.74903 1.29126 7.2853C1.09898 6.82158 1 6.3245 1 5.82252C1 5.32053 1.09898 4.82347 1.29126 4.35976C1.48353 3.89605 1.76533 3.47479 2.12055 3.12008C2.47503 2.76459 2.89621 2.48263 3.35997 2.29042C3.82374 2.0982 4.32097 1.9995 4.82299 2C5.32467 1.99956 5.82144 2.09829 6.28483 2.29051C6.7482 2.48274 7.16909 2.76465 7.52313 3.12008L8.00033 3.59732C8.71101 4.30651 9.27488 5.14884 9.65971 6.07614C10.0446 7.00342 10.2428 7.99752 10.2431 9.00147C10.2434 10.0055 10.0458 10.9997 9.6616 11.9272C9.27733 12.8548 8.71398 13.6975 8.00381 14.4071Z"
        fill="#E75E3C"
        className="path-fill"
      />
    </svg>
  );
}
